import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../service/auth.service';

const roleGuard = (allowed: string[]) => () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.roles$.pipe(take(1), map(roles =>
    roles.some(role => allowed.includes(role)) ? true : router.createUrlTree(['/forbidden'])
  ));
};

export const telehealthFieldGuard = roleGuard([
  'super_admin', 'org_admin', 'admin', 'clinical_admin',
  'nurse', 'rn', 'registered_nurse', 'lpn', 'lvn', 'wound_nurse'
]);
export const telehealthProviderGuard = roleGuard(['provider', 'np']);
